import { FC, useState } from 'react';
import { CandidateType } from '../Candidates/Candidates';
import ButtonLink from 'components/ButtonLink';
import { PopupModal } from 'components/PopupModal';
import { getRecipientIdByType } from 'helpers/donate';
import { IRecipientIdEnum } from 'store/recipients/types';
import { getAllPages } from 'selectors/pages';
import { getUrlParams } from 'helpers/utils';
import { useAppSelector } from 'helpers/hooks';
import { getEventData } from 'selectors/event';
import { ProcessingRedirectOptions } from 'store/pages/constants';

interface Props {
  candidates: CandidateType[];
}

export const CustomLinkCopy: FC<Props> = ({ candidates }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { urlEvent } = getUrlParams();
  const { allPages, eventData } = useAppSelector(state => ({
    allPages: getAllPages(state),
    eventData: getEventData(state),
  }));

  const getCustomLink = () => {
    const page = urlEvent ? eventData : allPages[0];
    const isStripe = page?.processing_redirect === ProcessingRedirectOptions.STRIPE;
    const urlPath = isStripe ? 'donate/checkout/standard' : 'checkout';
    const recipientIdType = isStripe ? IRecipientIdEnum.OATH_ID : IRecipientIdEnum.EXT_DE_URL_ID;
    const recipientsStr = candidates
      .filter(can => can.isSelected)
      .map(can => `${getRecipientIdByType(can, recipientIdType)}:${can.donationAmount}`)
      .join(';');
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.set('recipients', recipientsStr);
    return decodeURIComponent(urlObj.toString().replace('donate', urlPath));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(getCustomLink());
    setIsPopupOpen(true);
    setTimeout(() => setIsPopupOpen(false), 2000);
  };

  return (
    <>
      <PopupModal autoClose={true} isSelected={isPopupOpen} title="Copied to Clipboard" />
      <ButtonLink onClick={handleCopy}>Copy Checkout Link</ButtonLink>
    </>
  );
};
